import React from 'react';
import { CountdownProvider } from './contexts/CountdownContext';
import { TopBar } from './components/TopBar';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { IncludedSection } from './components/IncludedSection';
import { PlannerCarousel } from './components/PlannerCarousel';
import { ResultsSection } from './components/ResultsSection';
import { AboutCaro } from './components/AboutCaro';
import { Testimonials } from './components/Testimonials';
import { PurchaseSection } from './components/PurchaseSection';
import { Faq } from './components/Faq';
import { Footer } from './components/Footer';
export function App() {
  return <CountdownProvider data-id="element-0" data-mp="2whxd1y9zzwht">
      <div className="w-full bg-polar font-sans" data-id="element-1" data-mp="28u5zysgmvffh">
        <TopBar data-id="element-2" data-mp="28suv0pbgc1ms" />
        <main data-id="element-3" data-mp="28sbar1ybx15l">
          <Hero data-id="element-4" data-mp="23vck4tdvjcc5" />
          <ProblemSection data-id="element-5" data-mp="23vune9yyeqtk" />
          <SolutionSection data-id="element-6" data-mp="23ujkecdc1n3i" />
          <IncludedSection data-id="element-7" data-mp="23t8hsfvmildz" />
          <PlannerCarousel data-id="element-8" data-mp="3ik7gihlkcdr6" />
          <ResultsSection data-id="element-9" data-mp="3iiwdwl3utc1n" />
          <AboutCaro data-id="element-10" data-mp="3ijpbowku4r7n" />
          <Testimonials data-id="element-11" data-mp="3ii4ro0w5cqo1" />
          <PurchaseSection data-id="element-12" data-mp="3ml14faz09sk2" />
          <Faq data-id="element-13" data-mp="3mk8710lxsfel" />
        </main>
        <Footer data-id="element-14" data-mp="3mjga9mglsbmq" />
      </div>
    </CountdownProvider>;
}